import type { Piece } from '../shared/types';
import type { Point } from './board-projection';

export interface PawnHit { pieces: Piece[]; anchor: Point; width: number; height: number }
/** Do not let paint order decide which overlapping character the user meant. */
export function overlappingPawns(hits:PawnHit[], pointer:Point):PawnHit[] {
  return hits.filter(hit => pointer.x >= hit.anchor.x-hit.width/2 && pointer.x <= hit.anchor.x+hit.width/2 && pointer.y >= hit.anchor.y-hit.height && pointer.y <= hit.anchor.y+6)
    .sort((a,b)=>a.anchor.y-b.anchor.y || a.pieces[0].id.localeCompare(b.pieces[0].id));
}
